import type { AlertDto, IsoDateTimeString, UuidString } from "@/lib/api/types";
import type { AlertStreamEntry } from "@/store/realtime";

function readUuid(v: unknown): UuidString | null {
  if (typeof v === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(v)) {
    return v as UuidString;
  }
  return null;
}

function readString(v: unknown): string | null {
  return typeof v === "string" ? v : null;
}

/**
 * Best-effort map of WS `alerts` / `alert` payloads into {@link AlertDto} for list merging.
 */
export function alertDtoFromStreamEntry(entry: AlertStreamEntry): AlertDto {
  const p = entry.payload;
  const idRaw = p.id;
  const id: UuidString =
    typeof idRaw === "string" ? (idRaw as UuidString) : (entry.id as UuidString);

  const createdRaw = p.created_at ?? p.createdAt;
  let created_at: IsoDateTimeString;
  if (typeof createdRaw === "string") {
    created_at = new Date(createdRaw).toISOString() as IsoDateTimeString;
  } else if (typeof createdRaw === "number") {
    created_at = new Date(createdRaw).toISOString() as IsoDateTimeString;
  } else {
    created_at = new Date(entry.createdAt).toISOString() as IsoDateTimeString;
  }

  return {
    id,
    device_id: readUuid(p.device_id ?? p.deviceId),
    tenant_id: readUuid(p.tenant_id ?? p.tenantId),
    rule_id: readUuid(p.rule_id ?? p.ruleId),
    message: readString(p.message ?? p.text ?? p.body),
    severity: readString(p.severity ?? p.level),
    created_at,
    status: readString(p.status ?? p.alert_status) ?? "active",
  };
}
